import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Select } from "antd";
import LazyLoadSelect from "./LazyLoadSelect";
const TenantSelect = ({ value, disabled = false, allowClear = false, placeholder = "Select a profile", style, onChange, onTenantSelected }) => {
    const [tenants, setTenants] = useState([]);
    const optionsRenderer = (tenants) => {
        return tenants.map((tenant) => {
            return _jsx(Select.Option, { value: tenant.id, filter: tenant.name, children: tenant.name }, tenant.id);
        });
    };
    const onSelectChange = (sTenantId) => {
        const tenantId = Number(sTenantId);
        onChange && onChange(tenantId);
        if (onTenantSelected && tenants.length > 0) {
            const selectedTenant = tenants.find(t => t.id == tenantId);
            if (selectedTenant) {
                onTenantSelected(selectedTenant);
            }
        }
    };
    return (_jsx(LazyLoadSelect, { url: "/admin/v1/tenants", searchKey: "nameLike", queryParams: {
            active: true,
            creditSummary: false,
            summary: true
        }, disabled: disabled, allowClear: allowClear, placeholder: placeholder, notFoundMessage: "No Profiles Found", style: style, onChange: onSelectChange, value: value, optionsRenderer: optionsRenderer, onDataLoaded: setTenants }));
};
export default TenantSelect;
